import { Brand, Practice, Staffer } from '@principle-theorem/principle-core';
import { IStaffer } from '@principle-theorem/principle-core/interfaces';
import {
  Firestore,
  toTimestamp,
  type Query,
  type WithRef,
} from '@principle-theorem/shared';
import { BigQueryJobName } from '../../job-names';
import { IStafferWriteTopicData } from '../../topic-data/topic-data';
import {
  BasicBigQuerySyncHandler,
  IBigQuerySyncRequest,
} from '../big-query-sync';

export class BigQueryStaffSyncHandler extends BasicBigQuerySyncHandler<
  IStaffer,
  IStafferWriteTopicData
> {
  readonly bigQueryJobName = BigQueryJobName.StafferWrite;

  getQuery(request: IBigQuerySyncRequest): Query<IStaffer> {
    const brandRef = Practice.brandRef({ ref: request.practiceRef });
    return Brand.stafferCol({ ref: brandRef });
  }

  async getTopicData(
    staffer: WithRef<IStaffer>
  ): Promise<IStafferWriteTopicData> {
    const brand = await Firestore.getDoc(Staffer.brandRef(staffer));
    const organisation = await Firestore.getDoc(Brand.organisationRef(brand));
    return {
      organisation,
      brand,
      staffer,
      timestamp: toTimestamp(),
    };
  }
}
